import { createFileRoute } from '@tanstack/react-router'
import { EvalPlayground } from '@/features/admin/eval-playground'

export const Route = createFileRoute('/_authenticated/admin/eval-playground/')({
  component: EvalPlayground,
})
